/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRemoveLink = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M22.707 17.707 20.915 19.5l1.793 1.793-1.414 1.414-1.793-1.793-1.793 1.793-1.414-1.414 1.793-1.793-1.793-1.793 1.414-1.414 1.793 1.793 1.793-1.793zM9.171 10.585l-2.828 2.83a3 3 0 1 0 4.242 4.242l2.83-2.828 1.414 1.414L12 19.07A5 5 0 0 1 4.93 12l2.827-2.83z" />
        <path d="M16.243 9.171 9.17 16.243l-1.414-1.414 7.072-7.072z" />
        <path d="M12 4.93A5 5 0 1 1 19.07 12l-2.827 2.829-1.414-1.414 2.828-2.83a3 3 0 1 0-4.242-4.242l-2.83 2.828-1.414-1.414z" />
      </g>
    </g>
  </Icon>
);
export { SvgRemoveLink as RemoveLink };
